import store from 'store/index';
import { post } from 'store/request';

// 面登陆可上报的 event
const unloginEvent: string[] = [
  'banner_to_tool',
  'regist_page', // 注册页面
  // 'isv_manage_entry', // 进入isv 系统
  // 'agency_manage', // 服务商管理
  // 'application_manage', // 应用管理
];

export interface Report {
  event: string;
  page?: string;
  url?: string;
  client_id?: string;
  payload?: string;
  logins?: Record<'login_type' | 'login_name_type' | 'login_name', string | number>;
}

let list: Report[] = [];

export const report = (data: Report) => {
  const { user } = store.getState().user;
  let logins = {
    login_type: user?.login_type,
    login_name_type: user?.login_name_type,
    login_name: user?.qq_number || user?.wx_id,
  };
  if (!user && unloginEvent.includes(data.event)) {
    logins = {
      login_type: 0,
      login_name_type: 0,
      login_name: '',
    };
  }
  list.push({
    ...data,
    page: `/${location.pathname.split('/')?.[1]}`,
    logins,
  });
};

export const setReportUser = () => {
  const { user } = store.getState().user;
  const logins = {
    login_type: user?.login_type,
    login_name_type: user?.login_name_type,
    login_name: user?.qq_number || user?.wx_id,
  };
  list = list?.map((item) => ({
    ...item,
    logins,
  }));

  if (location.host === 'isv.e.qq.com' || location.host === 'pretest-isv.e.qq.com') {
    window.aegis?.setConfig({
      uin: JSON.stringify(logins),
    });
  }
};

if (location.host === 'isv.e.qq.com' || location.host === 'pretest-isv.e.qq.com') {
  const timeout = () => {
    setTimeout(() => {
      list = list.filter((item) => {
        return item?.logins?.login_name || unloginEvent.includes(item.event);
      });
      if (list.length) {
        post('/user_operations', { list }).then(() => {
          list = [];
        });
      }
      timeout();
    }, 3000);
  };
  timeout();

  const handleBeforeUnload = () => {
    if (!list.length) {
      return;
    }

    post('/user_operations', { list });
  };
  window.addEventListener('beforeunload', handleBeforeUnload, { capture: true });
}
